import '../css/style.scss'

require('./components/ue_base.js')
require('./components/ue_ui.js')
require('./components/ue_lazyload.js')
require('./components/ue_loader.js')
require('./components/ue_daguan.js')
require('./components/ue_addToDesktop.js')
require('./components/jquery.stickem.js')

$(function () {
  /*FastClick.attach(document.body);*/

  $('.js-nav-drag').each(function () {
    var $nav = $(this)
    new Swiper($nav, {
      freeMode: true,
      slidesPerView: 'auto',
      slideClass: 'item',
    })
  })

  $('[data-show-more-btn]').each(function () {
    const $btn = $(this)
    const $content = $btn.siblings('[data-show-more-content]'),
      showCount = $content.attr('data-show-more-count')
        ? $content.attr('data-show-more-count')
        : 6
    $btn.on('click', function () {
      $content.find('li:hidden').slice(0, showCount).show()
      if ($content.find('li:hidden').length === 0) {
        $btn.hide()
      }
      resetHeight()
    })
  })

  function getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r) return unescape(r[2])
    return null
  }
  var tab = getUrlParam('tab')

  /*  new Swiper($('.js1-nav-drag'),{
    freeMode : true,
    slidesPerView : 'auto',
    slideClass : 'item'
  });*/

  $('.ue-loader-hide').hide()
  var initTab = function () {
    var _this = $(this),
      tab_item = _this.find('.tab a')
    var tab_swiper = new Swiper(_this.find('.swiper-container'), {
      onInit: function () {
        $('.swiper-wrapper', _this).height(
          $('.swiper-slide', _this).eq(0).height(),
        )
      },
      onSlideChangeStart: function () {
        _this.find('.tab .active').removeClass('active')
        tab_item.eq(tab_swiper.activeIndex).addClass('active')
        // if(_this.attr('id') != 'ue-news'){
        $('.swiper-wrapper', _this).height(
          $('.swiper-slide', _this).eq(tab_swiper.activeIndex).height(),
        )
        // }
      },
      onSlideChangeEnd: function () {
        /*alert(1);
        if(_this.find('.fixed-style').length>0){*/
        /*alert(3)*/
        $(document).scrollTop(8 + _this.offset().top)
        /*}*/
      },
      //解决transform与fixed不能共存的bug
      onTransitionEnd: function () {
        //新闻延迟加载
        /*if(_this.attr('id') == 'ue-news'){
         	newsLoader.load(_this.find('.ue-news-link.active'));
        }*/
        if (tab_swiper.activeIndex === 0) {
          $('.swiper-wrapper', _this).css('transform', 'none')
        }
        initMainStickem()
        $('.swiper-wrapper', _this).height(
          $('.swiper-slide', _this).eq(tab_swiper.activeIndex).height(),
        )
      },
    })
    /*});*/
    tab_item.on('touchstart mousedown', function (e) {
      //e.preventDefault();
      _this.find('.tab .active').removeClass('active')
      $(this).addClass('active')
      tab_swiper.slideTo($(this).index())
      if (_this.find('.fixed-style').length > 0) {
        $(document).scrollTop(_this.offset().top)
      }
    })

    if (tab && _this.attr('id') == 'ue-news') {
      /*if(~navigator.userAgent.toLowerCase().indexOf('ucbrowser')){
				tab_swiper.slideTo(tab - 1);
        if(_this.attr('id') != 'ue-news'){
          setTimeout(function(){
            tab_swiper.slideTo(0);
          },100);
        }
      }
      else */
      tab_swiper.slideTo(tab - 1)
    }
    /*console.log(location)*/
    /*tab_item.click(function(e){
      e.preventDefault();
    });*/
  }

  $('.js-focus').each(function () {
    var _this = $(this)
    var length = _this.find('.swiper-wrapper li').length
    var focus_swiper = new Swiper(_this, {
      slidesPerView: 2,
      centeredSlides: true,
      spaceBetween: '3%',
      pagination: _this.find('.swiper-nav'),
      initialSlide: Math.floor(Math.random() * length),
      loop: true,
      autoplay: 4000,
    })
    window.ued = window.ued || {}
    window.ued.focusSlide = focus_swiper
  })

  $('.js-tab').each(initTab)

  var resetHeight = function () {
    $('.swiper-wrapper').each(function (i, n) {
      var $n = $(n)
      $n.height($n.find('.swiper-slide-active').height())
    })
  }

  //todo优化
  $(document.body)
    .bind('imgLoaded', function (e, html) {
      resetHeight()
    })
    .bind('appendHtml', function () {
      resetHeight()
    })

  var stickem,
    stickemOption = {
      item: '[data-fixed="element"]',
      container: '[data-fixed="container"]',
      stickClass: 'fixed-style',
    }
  var initMainStickem = function () {
    stickem && stickem.destroy()
    $('.fixed-style').removeClass('fixed-style')
    stickem = $('.content').stickem(stickemOption)
  }
  initMainStickem()

  $(document.body).bind('appendHtml', function (e, targetEl) {
    var $t = $(targetEl)
    $t.find('.js-tab').each(initTab)
    initMainStickem()
  })

  //游戏导航展开更多
  $('.js-game-index-toggle').click(function () {
    var _this = $(this),
      p = _this.parents('.game-index-name')

    if (p.hasClass('active')) {
      p.removeClass('active')
      _this.html('展开更多')
    } else {
      p.addClass('active')
      _this.html('收起')
    }
  })

  //滚到上面去
  $(window).scroll(function () {
    if ($(window).scrollTop() > $('.js-focus').scrollTop()) {
      $('.btn-gotop-arrow').fadeIn()
      $('.page-hide').siblings('.wrap').removeClass('page-show')
    } else {
      $('.btn-gotop-arrow').fadeOut()
      $('.page-hide').siblings('.wrap').addClass('page-show')
    }
  })
  $('.btn-gotop-arrow').click(function () {
    $('.fixed-style').removeClass('fixed-style')
    $(document).scrollTop(0)
  })

  new ue.Lazyload()

  new ue.Loader($('.data-ui-defer'))

  //站点导航菜单
  var siteMenu = new ue.Loader($('.btn-menu'), {
    callback: function (isFirstLoad) {
      var pageSub = $('#page-sub'),
        pageIndex = $('#page-index'),
        sticky
      // $('#ue-game-nav').width($(document.body).width());
      /*var initStickem = function(){
				return pageSub.stickem({
          item: '#ue-game-nav',
          container: '#ue-game-all',
          stickClass: 'fixed-style'
        });
      };*/

      pageIndex.removeClass('page-show').addClass('page-hide')
      pageSub.removeClass('page-hide').addClass('page-show')
      setTimeout(function () {
        $('.page-hide').hide()
        /*      var sw = $('#page-sub .swiper-wrapper');
        sw.height(sw.find('.swiper-slide-active').height());*/
      }, 650)
      if (isFirstLoad) {
        $('.btn-close').click(function () {
          //统计
          window.homeHot && homeHot.scroll()
          $('.page-hide').show()
          setTimeout(function () {
            pageIndex.removeClass('page-hide').addClass('page-show')
            pageSub.removeClass('page-show').addClass('page-hide')
            resetHeight()
          }, 100)
        })

        //找游戏锚点
        var gameNavEl = $('#ue-game-nav')
        $('#ue-game-nav a').on('click', function (e) {
          gameNavEl.addClass('fixed-style')
          var targetTop = $($(this).attr('href')).offset().top - 70
          $(document).scrollTop(targetTop)
          e.preventDefault()
        })

        //跳转到a-z的按钮
        $('#ue-atoz').on('click', function () {
          $('.btn-menu:eq(1)').trigger('click')
        })
        //从新计算高度防止空白过长
        //sticky = initStickem();

        /*$('#ue-game-typetab a').on('click',function(){
          if($(this).attr('data-az')){
            sticky = initStickem();
          }
          else{
            sticky.destroy();
          }
        });*/
      }
    },
  })

  new ue.Loader($('.btn-loadsubpage'), {
    callback: function (isFirstLoad, targetEl) {
      var pageSub = $('#page-sub'),
        pageIndex = $('#page-index')
      pageIndex.removeClass('page-show').addClass('page-hide')
      pageSub.removeClass('page-hide').addClass('page-show')
      setTimeout(function () {
        $('.page-hide').hide()
      }, 650)
      if (isFirstLoad) {
        targetEl.find('.btn-close').click(function () {
          $('.page-hide').show()
          setTimeout(function () {
            pageIndex.removeClass('page-hide').addClass('page-show')
            pageSub.removeClass('page-show').addClass('page-hide')
          }, 100)
        })
      }
    },
  })

  //查看全部按钮会定位到站点导航的游戏部分
  /*  $('#ue-goto-allgame').on('click',function(){
    siteMenu.load(null,function(){
			$(window).scrollTop($('.ue-game-all').offset().top);
    });
  });*/

  //新闻
  /*  var newsLoader = new ue.Loader($('.ue-news-link'),{
    callback:function(isFirstLoad,targetEl){
      targetEl.parents('.swiper-wrapper').height(targetEl.parents('.swiper-slide').height());
      initMainStickem();
      initComment();
    }
  });*/

  //评论
  var initComment = function () {
    var cItem = $('.js-comment-item'),
      length = cItem.length,
      maxIndex = 0
    cItem.each(function (i, n) {
      var $n = $(n)
      if ($n.attr('data-topicid')) {
        var index = Math.floor(i / 20)
        maxIndex = index > maxIndex ? index : maxIndex
        $n.addClass('js-comment-item' + index)
      }
      $n.removeClass('js-comment-item')
    })
    for (var i = 0; i <= maxIndex; i++) {
      new CommentInfo({
        commentItem: '.js-comment-item' + i,
        commentType: 2,
      }).init()
    }
  }

  new ue.Loader($('.ue-news-loader'), {
    append: true,
    beforeAppend: function () {
      $('.js-comment-item').removeClass('js-comment-item')
    },
    callback: function (isFirestLoad, targetEl, el) {
      el.attr('loader-link', 'true')
      el.text('查看更多')
      if (isFirestLoad) {
        initMainStickem()
        initComment()
      }
    },
  })

  //新闻后四个标签页是cms自动生成的内容,后端不支持分页,所以一次加载完然后隐藏一半,点击更多再显示另一半的.
  $('.ue-news-more').on('click', function (e) {
    var me = $(this),
      targetEl = me.parent().find('.ue-loader-hide')
    targetEl.show()

    initMainStickem()
    me.unbind('click')
    me.text('查看更多')
    e.preventDefault()
  })

  setTimeout(function () {
    $('.ue-news-more,.ue-news-loader').trigger('click')
  }, 1000)

  //娱乐大观
  new ue.Daguan($('#ue-daguan'), {
    totalPage: 3,
    //urlTemplate:'http://10.5.15.99:10086/inc-lazyload/daguan-{index}.shtml'
    urlTemplate: 'http://m.17173.com/2015/m/daguan/daguan-{index}.shtml',
  })
  initComment()

  //统计
  $('.ico-font-menu').on('click', function () {
    window.homeHot && homeHot.scroll()
  })

  //跳转到pc版按钮监控
  $('.link-gopc').on('click', function () {
    window._jc_pingjs &&
      window._jc_pingjs('click', {
        appkey: 181,
        u: $(this).attr('href') + '?p=mobilegotopc',
      })
  })

  var hashTimer = null,
    hashTime = 100
  if (~navigator.userAgent.toLowerCase().indexOf('baidu')) {
    hashTime = 2000
  }

  /*  var scrollToHash = function(hash){
    clearTimeout(hashTimer);
    hashTimer = setTimeout(function(){
    	window.location  = '#' + hash;
    },hashTime);
  };*/

  var urlHash = location.hash
  if (!urlHash && tab) urlHash = '#hashToNews'
  urlHash &&
    $('.js-focus img').load(function () {
      clearTimeout(hashTimer)
      hashTimer = setTimeout(function () {
        window.location = urlHash
      }, hashTime)
    })

  new ue.AddToDesktop('.gb-app-gamerss')
})
